export enum ManifestType {
    Dynamic = 'Dynamic',
    Static = 'Static',
}
